import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LoaderSpinnerService {

  private display: boolean = true;
  private counter: number = 0;
  private spinner = new BehaviorSubject<boolean>(true);

  constructor() { }

  public getSpinner(): Observable<boolean> {
    return this.spinner.asObservable();
  }

  public show() {
    this.counter++;
    if (this.counter == 1) {
      this.spinner.next(this.display);
    }
  }

  public hide() {
    this.counter--;
    if (this.counter == 0) {
      this.spinner.next(!this.display);
    }
  }
}